\
<template>
    <div class="spring">
        <!-- countries SEE -->
        <div v-if="$root.selectedCountry.postpaid === 1">
            <div class="bundle bundle--horizontal">
                <div class="bundle__summary">
                    <div class="grid">
                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--md-1/1 grid__item--1/1">
                            <h4 class="grid--gutter gutter--md-bottom grid">
                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom">
                                    <span class="heading heading--4 heading--light heading--leading heading--trailing">Beneficiile tale naționale sunt disponibile și în roaming.</span>
                                </span>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <h2 class="heading heading--4 heading--light heading--leading heading--center">Tarife standard</h2>
            <h3 class="heading heading--5 heading--light heading--leading heading--center mt-20">
                Te bucuri de aceleași beneficii ca acasă și în
                <strong v-html="$root.selectedCountry.name"></strong>
                , în condițiile politicii de utilizare rezonabilă.
            </h3>
            <calculator :countryName="$root.selectedCountry.name"></calculator>
        </div>

        <!-- countries no SEE & rz zones -->

        <div v-if="$root.selectedCountry.postpaid !== 1">
            <h2 class="heading heading--4 heading--light heading--leading heading--center">Tarife standard</h2>
            <card-standard-tarifs :selectedCountry="$root.selectedCountry" :zoneProps="GET_ZONE_DATA"></card-standard-tarifs>
        </div>
    </div>
</template>
<script>
import Calculator from './Calculator.vue';
import CardStandardTarifs from './CardStandardTarifs.vue';
export default {
    components: { Calculator, CardStandardTarifs },
    props: ['countryZone'],
    computed: {
        GET_ZONE_DATA() {
            if (!this.$root.selectedCountry) return {};
            else {
                return this.$root.zones[0].find((item) => item['Zona'] === this.countryZone);
            }
        },
    },
};
</script>
